import { ReactComponent as WarningIcon } from '../../../assets/images/blueTheme/alertTriangle.svg';
import { ReactComponent as ExclamationIcon } from '../../../assets/images/blueTheme/exclamationMark.svg';
import { ReactComponent as InformationMark } from '../../../assets/images/blueTheme/informationMark.svg';
import theme from '../../../theme';
import { NotificationElements, NotificationType } from './types';

export const notificationOptions: Record<NotificationType, NotificationElements> = {
  [NotificationType.warning]: {
    icon: <WarningIcon data-testid="warningNotificationIcon" />,
    backgroundColor: theme.admanColors!.yellow.dark.bg1[1],
    backgroundBorderColor: theme.admanColors!.yellow.dark.bg1[2],
    contentColor: theme.admanColors!.yellow.dark.bg1[0],
    defaultTitle: 'Warning',
  },
  [NotificationType.error]: {
    icon: <ExclamationIcon data-testid="errorNotificationIcon" />,
    backgroundColor: theme.admanColors!.red.light.bg1[0],
    backgroundBorderColor: theme.admanColors!.yellow.dark.bg1[1],
    contentColor: theme.admanColors!.red.light.bg1[2],
    defaultTitle: 'Error',
  },
  [NotificationType.info]: {
    icon: <InformationMark data-testid="infoNotificationIcon" />,
    backgroundColor: theme.admanColors!.blue.light.fg[4],
    backgroundBorderColor: theme.admanColors!.indigo.solid,
    contentColor: theme.admanColors!.blue.dark.bg1[0],
    defaultTitle: 'Information',
  },
};
